module.exports = __webpack_public_path__ + "static/media/transportation.8ef46cb3.png";